(function (app) {

    app.value("locationList", [
        {
            IconClass: "fig-building",
            Type: "Event Venue",
            Name: "Financial Independence Group",
            Address: "19600 West Catawba Avenue, Suite C",
            CityState: "Cornelius, NC 28031",
            MapUrl: "https://maps.google.com/?q=Financial+Independence+Group%2C+19520+West+Catawba+Avenue%2C+Suite+200%2C+Cornelius%2C+North+Carolina+28031",
            Info: "Registration is complementary, travel is the responsibility of the attendee."
        },
        {
            IconClass: "fig-bed",
            Type: "Hotel Information",
            Name: "Comfort Inn and Suites",
            Address: "19521 Liverpool Parkway",
            CityState: "Cornelius, NC 28031",
            MapUrl: "https://maps.google.com/?q=Comfort+Inn+and+Suites%2C+19521+Liverpool+Parkway%2C+Cornelius%2C+North+Carolina+28031",
            Info: "Financial Independence Group has a group rate of $80 per night plus tax and fees. Ask for FIG Rate when booking."
        },
        {
            IconClass: "fig-plane",
            Type: "Airport Information",
            Name: "Charlotte Douglas Int'l Airport",
            Address: "5501 Josh Birmingham Parkway",
            CityState: "Charlotte, NC 28208",
            MapUrl: "https://maps.google.com/?q=Charlotte+Douglas+International+Airport",
            Info: "Distance from airport to hotel: 23 miles."
        }
    ]);

})(window.app, window.angular); //jshint ignore:line